document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll('[data-product-section] .product-media img')
    .forEach((img) => {
      // Wrap pour clipper le zoom
      if (!img.closest(".zoom-wrap")) {
        const wrap = document.createElement("div");
        wrap.className = "zoom-wrap";
        img.parentNode.insertBefore(wrap, img);
        wrap.appendChild(img);
      }

      const wrap = img.closest(".zoom-wrap");

      img.style.userSelect = "none";
      img.draggable = false;

      const setOriginFromEvent = (e) => {
        const rect = img.getBoundingClientRect();
        const t = e.touches ? e.touches[0] : e;

        const x = ((t.clientX - rect.left) / rect.width) * 100;
        const y = ((t.clientY - rect.top) / rect.height) * 100;

        img.style.setProperty("--zoom-x", `${x}%`);
        img.style.setProperty("--zoom-y", `${y}%`);
      };

      const toggleZoom = (e) => {
        if (e.target.closest("button,a")) return;
        setOriginFromEvent(e);
        wrap.classList.toggle("is-zoomed");
      };

      // Desktop click
      img.addEventListener("click", toggleZoom);

      // Mobile: TAP only (pas au touchstart)
      let startX = 0;
      let startY = 0;
      let moved = false;

      img.addEventListener(
        "touchstart",
        (e) => {
          const t = e.touches && e.touches[0];
          if (!t) return;

          startX = t.clientX;
          startY = t.clientY;
          moved = false;

          // IMPORTANT : pas de preventDefault ici, sinon tu tues le swipe du carousel
        },
        { passive: true }
      );

      img.addEventListener(
        "touchmove",
        (e) => {
          const t = e.touches && e.touches[0];
          if (!t) return;

          const dx = Math.abs(t.clientX - startX);
          const dy = Math.abs(t.clientY - startY);

          // Si mouvement significatif => c'est un swipe, pas un tap
          if (dx > 8 || dy > 8) moved = true;

          // Si on est déjà zoomed, on peut déplacer le point de zoom
          if (!moved && wrap.classList.contains("is-zoomed")) {
            setOriginFromEvent(e);
          }
        },
        { passive: true }
      );

      img.addEventListener(
        "touchend",
        (e) => {
          // Si pas bougé => c'était un tap : on zoom
          if (!moved) {
            toggleZoom(e);
          }
        },
        { passive: true }
      );

      // Optionnel: dézoom quand on quitte (desktop)
      wrap.addEventListener("mouseleave", () => {
        wrap.classList.remove("is-zoomed");
      });
    });
});
